import Notes from './notes.container';

export default Notes;
